import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { UserContext } from "../../store/store"

export const Paginator = ({
  total,
  pageSize,
  offset,
  setOffset,
  radius = 5,
  skipers = true,
  iterators = true,
}) => {
  const [state] = useContext(UserContext)
  const theme = state.theme === "light" ? "" : "darkie"

  const cantPaginas = Math.ceil(total / pageSize)
  radius = Math.min(radius, cantPaginas)

  const pagActual = Math.floor((offset - 1) / pageSize) + 1,
    r = Math.floor(radius / 2),
    from = Math.min(
      pagActual - Math.min(r, pagActual - 1),
      cantPaginas - pagActual < r ? cantPaginas - radius + 1 : cantPaginas
    )

  const goToSegment = (segment) => setOffset(segment * pageSize + 1)

  const { t } = useTranslation()

  return (
    <>
      <nav className={"no-bg unselectable " + theme}>
        <ul className="pagination mx-auto flex-wrap">
          {skipers && (
            <li
              className={"page-item" + (pagActual === 1 ? " disabled" : "")}
              onClick={() => goToSegment(0)}>
              <span className="page-link">⇤</span>
            </li>
          )}

          {iterators && (
            <li
              className={"page-item" + (pagActual === 1 ? " disabled" : "")}
              onClick={() => goToSegment(pagActual - 2)}>
              <span className="page-link">{t(`ui.btns.prev`)}</span>
            </li>
          )}

          {Array(radius)
            .fill()
            .map((_, i) => (
              <li
                key={i}
                onClick={() => goToSegment(from + i - 1)}
                className={
                  "page-item" + (pagActual === from + i ? " active" : "")
                }>
                <span className="page-link">{from + i}</span>
              </li>
            ))}

          {iterators && (
            <li
              onClick={() => goToSegment(pagActual)}
              className={
                "page-item" + (pagActual === cantPaginas ? " disabled" : "")
              }>
              <span className="page-link">{t(`ui.btns.next`)}</span>
            </li>
          )}

          {skipers && (
            <li
              className={
                "page-item" + (pagActual === cantPaginas ? " disabled" : "")
              }
              onClick={() => goToSegment(cantPaginas - 1)}>
              <span className="page-link">⇥</span>
            </li>
          )}
        </ul>
      </nav>
    </>
  )
}
